export const blurObj = {
	image: true,
	icon: false,
	video: false,
	pageIndexContact: false,
	logo: false,
	silhouette: false,
	projectIcon: false,
};

export const typeDict = {
	image: 'Image',
	icon: 'Icon',
	video: 'Video',
	pageIndexContact: 'Page Index Contact',
	logo: 'Logo',
	silhouette: 'Silhouette',
	document: 'Document',
	'project-icon': 'Posillico Project Icon',
};

export const lowResObj = {
	image: true,
	icon: false,
	video: false,
	pageIndexContact: false,
	logo: false,
	silhouette: false,
	projectIcon: false,
};

export const assetIsImage = {
	image: true,
	icon: true,
	video: false,
	pageIndexContact: true,
	logo: true,
	silhouette: true,
	document: false,
	'project-icon': true,
};

export const getFiletypeIcon = contentType => {
	const extension = contentType?.split('/')[1];

	switch (extension) {

		case 'avi':
			return '/public/images/icons/filetype/avi-icon.png';

		case 'csv':
			return '/public/images/icons/filetype/csv-icon.png';

		case 'xls':
		case 'xlt':
		case 'xlm':
		case 'xlsx':
		case 'xlsm':
		case 'xltx':
		case 'xltm':
			return '/public/images/icons/filetype/excel-icon.png';

		case 'mp3':
			return '/public/images/icons/filetype/mp3-icon.png';

		case 'pdf':
			return '/public/images/icons/filetype/pdf-icon.png';

		case 'ppt':
		case 'pot':
		case 'pps':
		case 'pptx':
		case 'pptm':
		case 'potx':
		case 'potm':
		case 'ppam':
		case 'ppsx':
		case 'ppsm':
		case 'sldx':
		case 'sldm':
			return '/public/images/icons/filetype/ppt-icon.png';

		case 'rar':
			return '/public/images/icons/filetype/rar-icon.png';

		case 'txt':
			return '/public/images/icons/filetype/txt-icon.png';

		case 'doc':
		case 'docx':
		case 'docm':
		case 'dotx':
		case 'dotm':
		case 'docb':
		case 'msword':
			return '/public/images/icons/filetype/word-icon.png';

		case 'zip':
			return '/public/images/icons/filetype/zip-icon.png';

		default:
			return '/public/images/icons/filetype/universal-icon.png';
	}
};
